<div style="justify-items: center;">
    <form [formGroup]="cancellationForm" (ngSubmit)="sendCancelation()" class="cancellation-form">
        <p class="cancel-subscription-textarea-title">Please tell us in a few words why you'd like to cancel your subscription</p>
        <textarea formControlName="reason" required class="cancellation-textarea" rows="7"></textarea>
        <p class="cancel-subscription-textarea-title">Which delivery you would like to cancel from?</p>
        <div class="cancellation-dropdown-wrapper">
            <p-dropdown formControlName="cancelDate" [options]="cancellationDates" optionLabel="label" optionValue="value" placeholder="Select cancellation date"></p-dropdown>
        </div>
        <button type="submit" class="request-cancelation-button" [disabled]="!cancellationForm.valid">Request Cancelation</button>
    </form>
</div>
